import { render, staticRenderFns } from "./fleetCategory.vue?vue&type=template&id=18846d1e"
import script from "./fleetCategory.vue?vue&type=script&lang=js"
export * from "./fleetCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports